// extracted by extract-css-chunks-webpack-plugin
module.exports = {"space30":"space30-3mTK_tVf","col_w1000":"col_w1000-3UpSWW3Y"};